import { Alert, Button, Input, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import ActionModalShell from './ActionModalShell';

interface ActionConfirmationModalProps {
  confirmLabel: string;
  description: string;
  error?: string | null;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: (comment: string) => void;
  open: boolean;
  title: string;
}

export const ActionConfirmationModal = ({
  confirmLabel, description, error, loading = false, onCancel, onConfirm, open, title,
}: ActionConfirmationModalProps) => {
  const { t } = useTranslation();
  const [comment, setComment] = useState('');
  useEffect(() => {
    if (!open) setComment('');
  }, [open]);

  const close = () => {
    if (!loading) {
      setComment('');
      onCancel();
    }
  };
  return (
    <ActionModalShell
      busy={loading}
      footer={<div className="dms-action-modal__footer"><Button onClick={close} disabled={loading}>{t('actionsModal.cancel')}</Button><Button danger type="primary" loading={loading} onClick={() => onConfirm(comment.trim())}>{confirmLabel}</Button></div>}
      onCancel={close}
      open={open}
      title={title}
    >
      <div className="dms-action-modal__stack">
        <Typography.Paragraph className="dms-action-modal__target-summary">{description}</Typography.Paragraph>
        {error ? <Alert type="error" showIcon message={error} /> : null}
        <Input.TextArea
          aria-label={t('actionsModal.comment')}
          autoSize={{ minRows: 3, maxRows: 6 }}
          maxLength={250}
          onChange={(event) => setComment(event.target.value)}
          placeholder={t('actionsModal.commentPlaceholder')}
          showCount
          value={comment}
        />
      </div>
    </ActionModalShell>
  );
};
